import React, { Component } from 'react';
import { connect } from 'react-redux';

import './components/tenant_profile/TenantProfile.css';
import Paper from 'material-ui/Paper';

import TenantInfoEditable from './components/tenant_profile/TenantInfoEditable.js';
import EmergencyContact from './components/tenant_profile/EmergencyContact';
import OptOutSection from './components/tenant_profile/OptOutSection';
import AssistanceRequestSection from './components/tenant_profile/AssistanceRequestSection';

import { BounceLoader } from 'halogenium';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as tenantProfileActions from 'actions/tenantProfileActions';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

const Styles = {
  paper: {
    maxWidth: '650px',
    padding: '15px',
    margin: 'auto',
    borderRadius: '8px',
  },
  subMenuHeader: {
    backgroundColor: '#f7f7f7',
    margin: '20px -15px',
    paddingTop: '8px',
    textAlign: 'center',
    color: '#888888',
  },
  loading: {
    textAlign: 'center',
    width: '60px',
    margin: '30px auto auto auto',
  },
};

export default connect(
  store => ({
    generalDetails: store.tenantProfile.generalDetails,
    showPage: store.authentication.showPage,
  }),
  tenantProfileActions
)(
  class TenantProfile extends Component {
    componentDidMount() {
      this.props.getTenantProfile();
    }

    submitForm = formData => {
      return this.props.postUserProfileDetails(formData);
    };

    submitPhoto = files => {
      if (files && files.length) {
        this.props.postProfilePhoto(files[0]);
      }
    };

    render() {
      if (Object.keys(this.props.generalDetails).length === 0) {
        return this._renderLoadingTenantProfile();
      }
      return this._renderTenantProfileDetails();
    }

    _renderLoadingTenantProfile = () => {
      return (
        <div className="row" style={{ padding: '15px' }}>
          <Paper style={Styles.paper} zDepth={1}>
            <div className="row">
              <div style={Styles.loading}>
                <BounceLoader color={AccentColor()} />
              </div>
            </div>
          </Paper>
        </div>
      );
    };

    _renderTenantProfileDetails = () => {
      return (
        <div className="row" style={{ padding: '15px' }}>
          <Paper style={Styles.paper} zDepth={1}>
            <TenantInfoEditable
              submitPhoto={this.submitPhoto}
              onSubmit={this.submitForm}
              handleDocumentSubmit={this.submitForm}
              deleteTenantDocument={this.props.deleteTenantDocument}
            />
            {!hostIsCapreit() && (
              <RenderIfToggleOn toggle="ui.emergency_contacts">
                <EmergencyContact sub_menu_header_styling={Styles.subMenuHeader} />
              </RenderIfToggleOn>
            )}
            <RenderIfToggleOn toggle="ui.residents.account.show_opt_out">
              <OptOutSection />
            </RenderIfToggleOn>
            {
              this.props.generalDetails.request_assistance_enabled && (
                <AssistanceRequestSection 
                  requiresAssistance={this.props.generalDetails.requires_assistance}
                  assistanceRequest={this.props.generalDetails.assistance_request}
                  submitAssistanceRequest={this.props.updateAssistanceRequest}
                />
              )
            }
          </Paper>
        </div>
      );
    };
  }
);
